<script lang="ts">
import { computed, defineComponent } from 'vue';

import { makeSizeProps, makeThemeProps, provideTheme, useSize } from '../../composable';

import type { PropType } from 'vue';

export const componentName = 'CdsLoader';
export default defineComponent({
  name: componentName,
  props: {
    fixed: {
      type: Boolean as PropType<boolean>,
      default: false,
      description: 'Зафиксировать загрузчик относительно текущего контейнера'
    },
    overlay: {
      type: Boolean as PropType<boolean>,
      default: false,
      description: 'Отображать фиксированный полноэкранный загрузчик'
    },
    description: {
      type: String as PropType<string>,
      default: 'Загрузка',
      description: 'Укажите описание, которое лучше всего описывает состояние загрузки (aria-label)'
    },
    ...makeSizeProps(),
    ...makeThemeProps()
  },
  setup(props, { attrs }) {
    const { themeClasses } = provideTheme(props);
    const { sizeClasses } = useSize(props, componentName);

    const loaderClasses = computed(() => ({
      'cds-loader__overlay': props.overlay,
      'cds-loader__fixed': props.fixed
    }));

    return { attrs, loaderClasses, sizeClasses, themeClasses };
  }
});
</script>

<template>
  <div class :class="[loaderClasses, themeClasses]">
    <div
      role="progressbar"
      :aria-valuetext="description"
      :aria-label="description"
      class="cds-loader"
      :class="sizeClasses"
      v-bind="attrs"
    >
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10.5" />
      </svg>
    </div>
  </div>
</template>

<style lang="scss">
@import './CdsLoader';
</style>
